import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import apiClient from "./apiClient";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectedLocation: null,
    pricingPolicy: null,
    selectedStartDate: null,
    selectedEndDate: null,
    selectedStartTime: "00:00",
    selectedEndTime: "23:59",
    selectedPlaceSet: new Set(),
    selectedSeatSet: new Set(),
    availablePlaceSet: new Set(),
    adminProperties: null,
    locationList: [],
    locationPlaces: [],
    availableDates:[],
  },
  mutations: {
    SET_SELECTED_LOCATION(state, location) {
      state.selectedLocation = location;
    },
    SET_AVAILABLE_DATES(state, dates){
      state.availableDates = dates
    },
    SET_SELECTED_START_DATE(state, date) {
      state.selectedStartDate = date;
    },
    SET_SELECTED_END_DATE(state, date) {
      state.selectedEndDate = date;
    },
    SET_SELECTED_START_TIME(state, time) {
      state.selectedStartTime = time;
    },
    SET_SELECTED_END_TIME(state, time) {
      state.selectedEndTime = time;
    },
    SET_AVAILABLE_PLACES(state, places) {
      state.availablePlaceSet = new Set(places.map(place => place.id));
    },
    SET_SELECTED_PLACES(state, placeSet) {
      state.selectedPlaceSet = placeSet;
    },
    SET_LOCATION_PLACES(state, locationPlaces) {
      state.locationPlaces = locationPlaces;
    },
    SET_SEATS(state, seatSet) {
      state.selectedSeatSet = seatSet;
    },
    SET_PRICING_POLICY(state, pricingPolicy) {
      state.pricingPolicy = pricingPolicy;
    },
    SET_LOCATIONS(state, locations) {
      state.locationList = locations;
    },
    SET_ADMIN_PROPERTIES(state, properties) {
      state.adminProperties = properties;
    }
  },
  getters: {
    isSelectedPlace: state => {
      return state.selectedPlaceSet.size > 0;
    },
    selectedLocation: state => state.selectedLocation,
    orderPrice: state => {
      if (!state.pricingPolicy) {
        return "";
      }

      let daysCount, hoursCount, totalHours, placesCount;

      placesCount = state.selectedPlaceSet.size;

      if (state.selectedEndDate) {
        daysCount =
          state.selectedEndDate.diff(state.selectedStartDate, "days") + 1;
      } else {
        daysCount = 0;
      }

      hoursCount =
        parseInt(state.selectedEndTime.split(":")[0]) -
        parseInt(state.selectedStartTime.split(":")[0]) +
        1;
      totalHours = hoursCount * daysCount * placesCount;
      console.log(totalHours);
      console.log(state.pricingPolicy);
      if (state.pricingPolicy.longPeriodDurationHours <= totalHours) {
        console.log("Long period");
        return (
          state.pricingPolicy.longPeriodPrice * totalHours +
          state.adminProperties.currency.symbol +
          " на " +
          daysCount +
          " дней"
        );
      } else if (state.pricingPolicy.mediumPeriodDurationHours <= totalHours) {
        console.log("Medium period");
        return (
          state.pricingPolicy.mediumPeriodPrice * totalHours +
          state.adminProperties.currency.symbol +
          " на " +
          daysCount +
          " дней"
        );
      } else {
        console.log("Short period");
        return (
          state.pricingPolicy.shortPeriodPrice * totalHours +
          state.adminProperties.currency.symbol +
          " на " +
          daysCount +
          " дней"
        );
      }
    }
  },
  actions: {
    selectEventsStatus({ commit }, isEvent){
      commit('SET_ADMIN_EVENTS', isEvent)
    },
    selectLocation({ commit }, location) {
      commit("SET_SELECTED_LOCATION", location);
      commit("SET_SELECTED_PLACES", new Set());
    },
    selectStartDate({ commit }, date) {
      commit("SET_SELECTED_START_DATE", date);
      // commit("SET_SELECTED_PLACES", new Set());
    },
    selectEndDate({ commit }, date) {
      commit("SET_SELECTED_END_DATE", date);
      // commit("SET_SELECTED_PLACES", new Set());
    },
    selectStartTime({ commit }, time) {
      commit("SET_SELECTED_START_TIME", time);
      commit("SET_SELECTED_PLACES", new Set());
    },
    selectEndTime({ commit }, time) {
      commit("SET_SELECTED_END_TIME", time);
      commit("SET_SELECTED_PLACES", new Set());
    },
    clearSeats({ commit }) {
      commit("SET_SEATS", new Set());
    },

    selectSeat({ commit }, seatId) {
      if (this.state.selectedSeatSet.has(seatId)) {
        this.state.selectedSeatSet.delete(seatId);

      } else {
        this.state.selectedSeatSet.add(seatId);
      }
      commit("SET_SEATS", new Set(this.state.selectedSeatSet));
    },
    selectPlace({ commit }, place) {
      if (this.state.selectedPlaceSet.has(place.id)) {
        this.state.selectedPlaceSet.delete(place.id);
      } else {
        this.state.selectedPlaceSet.add(place.id);
      }
      commit("SET_SELECTED_PLACES", new Set(this.state.selectedPlaceSet));
    },
    fetchLocations({ commit }) {
      apiClient.get("/api/location").then(response => {
        commit("SET_LOCATIONS", response.data);
        commit(
          "SET_SELECTED_LOCATION",
          localStorage.getItem("selectedLocation")
            ? parseInt(localStorage.getItem("selectedLocation"))
            : response.data[0]
        );
      });
    },
    fetchAdminProperties({ commit }) {
      apiClient.get("/api/main/properties").then(response => {
        commit("SET_ADMIN_PROPERTIES", response.data);
      });
    },
    fetchNotAvailableDates({commit}){
      if(!this.state.selectedStartDate){
        commit("SET_SELECTED_START_DATE", null)
        commit('SET_SELECTED_END_DATE', null)
      }

      let params = new URLSearchParams()
      const arrayPlaces = Array.from(this.state.selectedPlaceSet)

      if(this.state.selectedPlaceSet.size === 0){
        params.append('placeIds', "")
      }else{
        arrayPlaces.forEach(place => {
          params.append('placeIds', String(place))
        })
      }
      apiClient.get('/api/place/getAvailableDates', {params:params}).then(response => {
        commit("SET_AVAILABLE_DATES", response.data)
      })
    },
    fetchAvailablePlaces({ commit }) {
      if (!this.state.selectedStartDate) {
        commit("SET_AVAILABLE_PLACES", []);
      } else {
        let params = new URLSearchParams();
        params.append("locationId", this.state.selectedLocation.id);
        params.append(
          "startDate",
          this.state.selectedStartDate.format("DD-MM-YYYY")
        );
        params.append("startTime", this.state.selectedStartTime);

        if (this.state.selectedEndDate) {
          params.append(
            "endDate",
            this.state.selectedEndDate.format("DD-MM-YYYY")
          );
          params.append("endTime", this.state.selectedEndTime);
        } else {
          this.state.selectedEndDate = this.state.selectedStartDate.clone();
          params.append(
            "endDate",
            this.state.selectedEndDate.clone().format("DD-MM-YYYY")
          );
          params.append("endTime", this.state.selectedEndTime);
        }

        apiClient
          .get("/api/place/available", { params: params })
          .then(response => {
            commit("SET_AVAILABLE_PLACES", response.data);
          })
      }
    },
    fetchStartData({ commit }) {
      apiClient.get("/api/main/properties").then(response => {
        commit("SET_ADMIN_PROPERTIES", response.data);

        apiClient.get("/api/location").then(response => {
          commit("SET_LOCATIONS", response.data);
          commit("SET_SELECTED_LOCATION", response.data[0]);

          apiClient
            .get("/api/place/location", {
              params: { locationId: this.state.selectedLocation.id }
            })
            .then(function(response) {
              commit("SET_LOCATION_PLACES", response.data);
            });

          apiClient
            .get("/api/location/prices", {
              params: { id: this.state.selectedLocation.id }
            })
            .then(function(response) {
              commit("SET_PRICING_POLICY", response.data);
            });
        });
      });
    },
    fetchPlaces({ commit }) {
      apiClient
        .get("/api/place/location", {
          params: { locationId: this.state.selectedLocation.id }
        })
        .then(function(response) {
          commit("SET_LOCATION_PLACES", response.data);
        });

      apiClient
        .get("/api/location/prices", {
          params: { id: this.state.selectedLocation.id }
        })
        .then(function(response) {
          commit("SET_PRICING_POLICY", response.data);
        });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js